module.exports = __webpack_public_path__ + "img/SocialMedia.1abf843a.svg";